import { Stack, Typography } from "@mui/material";
import { appSession } from "../TR3AD.ts";
import { useNavigate } from "react-router";
import { SessionNetwork } from "../sdo/SessionNetwork.ts";
import { appStyles } from "../AppStyles.ts";

const SessionNetworkCard = (props: { entry: SessionNetwork }) => {
    const navigate = useNavigate();

    function onSelect() {
        appSession.connect(props.entry, (success) => {
            if (success) {
                navigate(`/networks/` + props.entry.key);
            }
        });
    }

    return (
        <Stack
            direction="column"
            alignItems="center"         // <-- center all child content horizontally
            spacing={1}
            onClick={onSelect}
            sx={{
                ...appStyles.cardNetworkDetails,
                width: 230,
                height: 100,
                p: 2,
                cursor: "pointer",
            }}
        >
            <Stack
                direction="row"
                width="100%"
                alignItems="center"
                justifyContent="center"   // <-- center image and label in the row
                spacing={1}
                sx={{ textAlign: "center" }}
            >
                <img src="/images/network.svg" width={32} height={32} alt="network" />
                <Typography sx={appStyles.cardNetworkNameLabel} flexWrap="wrap">
                    {props.entry.name}
                </Typography>
            </Stack>
            <Typography
                sx={{ ...appStyles.cardNetworkKeyLabel, textAlign: "center", width: "100%" }}
                flexWrap="wrap"
            >
                {props.entry.key}
            </Typography>
        </Stack>
    );
};

export default SessionNetworkCard;
